export const Role = {
  SuperAdmin: "super-administrator",
  Admin: "administrator",
};
